import ProductionDTO from '@src/adapters/dto/production/ProductionDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  productions: ProductionDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/production',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProductionsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProductionsLazy;
